import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import { Code } from 'react-bytesize-icons';
import * as React from 'react';
export default {
  ShortCutDisplay,
  Code,
  React
};